import { Store } from 'effector'
import { $config } from '@store/config'
import { $pagerBackground } from './state'
import { WidgetConfig } from '@loctypes'
import { ConfigValues } from './types'
import { pulloutValues } from './helpers'

class PagerBackgroundModule {
  private _configValues: ConfigValues
  private _cacheKey: string

  constructor() {
    $config.updates.watch((config) => {
      this.configure(config)
      this.calculateValue()
    })
  }

  configure(config: WidgetConfig): void {
    this._configValues = pulloutValues(config)
  }

  async calculateValue(): Promise<void> {
    let value
    const { backgroundType, gradientId } = this._configValues
    const theme = this._configValues.colors.find(({ id }) => id === this._configValues.themeId)
    const mainColor = theme!.colors[0]
    const cacheKey = backgroundType === 'gradient' ? gradientId : mainColor

    if (this._cacheKey === cacheKey) {
      return
    } else {
      this._cacheKey = cacheKey
    }

    if (backgroundType === 'gradient' && this._configValues.enableWelcomePage) {
      const url = `${DEVELOPMENT ? '' : CHAT_SERVICE_URL}/assets/gradients/${gradientId}.png`
      const response = await fetch(url)
      const blob = await response.blob()

      value = `url(${URL.createObjectURL(blob)})`
    } else {
      const theme = this._configValues.colors.find(({ id }) => id === this._configValues.themeId)

      $pagerBackground.api.set(theme!.colors[0])
    }

    $pagerBackground.api.set(value)
  }

  get store(): Store<string> {
    return $pagerBackground.store
  }
}

export default new PagerBackgroundModule()
